import type { AnonymizationBody } from "@/schemas/anonymize.schema";
import type { RequestConfig } from "@/services/api";
import { api } from "@/services/api";

export const anonymizerApi = {
  caches: {
    entities: new Map<string, string[]>(),
  },

  async getEntities(language: string) {
    if (this.caches.entities.has(language)) {
      return this.caches.entities.get(language);
    }

    const { data } = await api.get<{
      entities: string[];
    }>(`/anonymize/entities/${language}`);

    this.caches.entities.set(language, data.entities);

    return data.entities;
  },

  async run(body: AnonymizationBody, config?: RequestConfig) {
    const { data } = await api.post("/anonymize", body, config);

    return data as { text: string };
  },
};
